module.exports = __webpack_public_path__ + "static/media/datagroFull.09e860e1.png";